module.exports = __webpack_public_path__ + "img/Realisme_Tanker_i_tida5.fb66cde8.jpg";